import axios from "axios";
import {url_local} from '../url'
//import state from "../../store";
import state from '../../store/index'


export function GetSucursales() {
    //console.log(state.state.currentUser.access_token);
    const config = {
        headers : {
            'Content-Type' : 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: "Bearer " +state.state.currentUser.access_token
        }
    }

    return new Promise((res, rej) => {
        axios.get(`${url_local}sucursal`, config).then(response => {
            res(response.data);
        })
        .catch(err => {
            rej("error al cargar las surcusales" + err);
        });
    });
    }

    export function GetSucursalesAll() {
        //console.log(state.state.currentUser.access_token);
        const config = {
            headers : {
                'Content-Type' : 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                Authorization: "Bearer " +state.state.currentUser.access_token
            }
        }
    
        return new Promise((res, rej) => {
            axios.get(`${url_local}sucursalAll`, config).then(response => {
                res(response.data);
            })
            .catch(err => {
                rej("error al cargar las surcusales" + err);
            });
        });
        }

    
    


    export function SubirSucursales(form) {
        //console.log(state.state.currentUser.access_token);
        const config = {
            headers : {
                'Content-Type' : 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                Authorization: "Bearer " +state.state.currentUser.access_token
            }
        }
    
        return new Promise((res, rej) => {
            axios.post(`${url_local}sucursal`,form ,config).then(response => {
                res(response.data);
            })
            .catch(err => {
                rej("error al subir la surcusal: " + err);
            });
        });
        }

        export function EditSucursal(id,form) {
            //console.log(state.state.currentUser.access_token);
            const config = {
                headers : {
                    'Content-Type' : 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    Authorization: "Bearer " +state.state.currentUser.access_token
                }
            }
        
            return new Promise((res, rej) => {
                axios.put(`${url_local}sucursal/${id}`,form ,config).then(response => {
                    res(response.data);
                })
                .catch(err => {
                    rej("error al editar la sucursal: " + err);
                });
            });
        }
        
        export function DeleteSucursal(id) {
            //console.log(state.state.currentUser.access_token);
            const config = {
                headers : {
                    'Content-Type' : 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    Authorization: "Bearer " +state.state.currentUser.access_token
                }
            }
        
            return new Promise((res, rej) => {
                axios.delete(`${url_local}sucursal/${id}` ,config).then(response => {
                    res(response.data);
                })
                .catch(err => {
                    rej("error borrar la sucursal: " + err);
                });
            });
        }
        
        
        
        
        export function Subirlocalidad(form){

            const config = {
                headers : {
                    'Content-Type' : 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    Authorization: "Bearer " +state.state.currentUser.access_token
                }
            }
        
            return new Promise((res, rej) => {
                axios.post(`${url_local}localidad`, form ,config).then(response => {
                    res(response.data);
                })
                .catch(err => {
                    rej("error al subir la localidad: " + err);
                });
            });

        }

        export function Deletelocalidad(id) {
            //console.log(state.state.currentUser.access_token);
            const config = {
                headers : {
                    'Content-Type' : 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    Authorization: "Bearer " +state.state.currentUser.access_token
                }
            }
        
            return new Promise((res, rej) => {
                axios.delete(`${url_local}localidad/${id}` ,config).then(response => {
                    res(response.data);
                })
                .catch(err => {
                    rej("error al eliminar la localidad: " + err);
                });
            });
        }
    

